import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleCiLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 71,
	height: 71,
	viewBox: "8.4375 8.4375 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_113679_634)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M28.6043 35.4375C28.6043 31.8735 31.4933 29.0138 35.028 29.0138C38.565 29.0138 41.454 31.9028 41.454 35.4375C41.454 38.9745 38.565 41.8635 35.028 41.8635C31.4955 41.8635 28.6043 38.9745 28.6043 35.4375ZM35.028 8.4375C22.4213 8.4375 11.862 17.0775 8.86503 28.7437C8.84253 28.8247 8.84253 28.9013 8.84253 29.0138C8.84253 29.718 9.40953 30.3097 10.1363 30.3097H21.015C21.5325 30.3097 21.9893 30.0172 22.1783 29.5605C24.4215 24.7005 29.3333 21.2985 35.0303 21.2985C42.8288 21.2985 49.1738 27.6435 49.1738 35.4443C49.1738 43.2518 42.8288 49.5967 35.0213 49.5967C29.3288 49.5967 24.4148 46.2217 22.1738 41.3325C21.9555 40.905 21.5213 40.5765 21.0105 40.5765H10.1363C9.43428 40.5765 8.84253 41.1457 8.84253 41.8725C8.84253 41.9557 8.87403 42.0345 8.87403 42.1425C11.844 53.7975 22.419 62.4375 35.028 62.4375C49.932 62.4375 62.028 50.3438 62.028 35.4375C62.028 20.5357 49.932 8.4375 35.028 8.4375Z",
				fill: "black"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_113679_634",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 54,
				height: 54,
				fill: "white",
				transform: "translate(8.4375 8.4375)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgCircleCiLogo);
export { ForwardRef as ReactComponent };
